import { Button, Card, Group, Stack, Title, rem } from '@mantine/core';
import WarningDiamondIcon from '@/assets/icons/warning-diamond-icon.svg';
import { ROUTES } from '@/config/router';
import { useRouter } from '@/navigation';

const TruckSuggestAlert = () => {
  const router = useRouter();
  const handleRedirectTruck = () => {
    // const baseUrl = process.env.NEXT_PUBLIC_API_URI;
    // window.location.href = `${baseUrl}/v3/truck`;
    router.push(ROUTES.truck);
  };

  return (
    <>
      <Card
        className="bg-yellow-10"
        radius={rem(4)}
        pos="absolute"
        top={'-50%'}
        style={{
          background: '#FFF7D6',
        }}
        styles={{
          root: {
            zIndex: 1,
            width: 'calc(100% - 32px)',
          },
        }}
      >
        <Group gap={8} justify="flex-start" align="flex-start">
          <WarningDiamondIcon className="size-6" />
          <Stack gap={8} justify="flex-start" align="flex-start">
            <Title order={6} c="neutral.7">
              Hàng hóa kích thước lớn phù hợp để giao bằng Xe Tải.
            </Title>
            <Button
              styles={{
                root: {
                  background: 'transparent',
                },
              }}
              fw={700}
              p={0}
              size="compact-md"
              c="secondary.4"
              variant="subtle"
              onClick={handleRedirectTruck}
            >
              Đặt đơn xe tải
            </Button>
          </Stack>
        </Group>
      </Card>
    </>
  );
};

export default TruckSuggestAlert;
